import Auth from './modules/auth'
import Categories from './modules/categories'
import Series from './modules/series'
import Links from './modules/links'
import Genres from './modules/genres'
import Serie from './modules/serie'
import Movie from './modules/movie'
import Movies from './modules/movies'
import Video from './modules/video'
import Voiceovers from './modules/voiceovers'
import Files from './modules/files'
import Seasons from './modules/seasons'
import Season from './modules/season'
import MassAdition from './modules/mass-adition'
import Directories from './modules/directories'
import AdTag from './modules/adtag'
import Studio from './modules/studio'

const api = {
    auth: new Auth(),
    categories: new Categories(),
    series: new Series(),
    links: new Links(),
    genres: new Genres(),
    serie: new Serie(),
    movie: new Movie(),
    movies: new Movies(),
    video: new Video(),
    voiceovers: new Voiceovers(),
    files: new Files(),
    seasons: new Seasons(),
    season: new Season(),
    massAdition: new MassAdition(),
    directories: new Directories(),
    adtag: new AdTag(),
    studio: new Studio()
}

export default api